export interface Sensors {
  id: number
  typeId: number
  name: string
  dataColumns: SensorDataColumns[]
}

export interface SensorDataColumns {
  columnName: string
  displayName: string
}

export interface SensorTypes {
  id: number
  name: string
}
export interface DataComparisonState {
  sensors: {
    isLoading: boolean
    data: Sensors[]
  }
  sensorTypes: {
    isLoading: boolean
    data: SensorTypes[]
  }
  chartDetails: {
    isLoading: boolean
    data: ChartData[]
  }
  currentCSVData?: string
  rightSidebarDetails: {
    variantName: string
    sensorStateData: any[]
    allSensorStateData: any[]
    checkedSensorParameter: any[]
    openSensor: any[]
    sensorType: any[]
    inputValue: string
  }
  timeGrouping: TimeGrouping | ''
  groupByFields: string[]
  groupByMode: 'all' | 'average'
  snapshotBeforePanelOpen?: any
}

export enum GroupByField {
  SOIL_MOISTURE = 'soil_moisture',
  SOIL_TEMPERATURE = 'soil_temperature',
  LONGITUDE = 'longitude',
  LATITUDE = 'latitude',
}

export type SensorHistoricDataRequestParams = {
  startDate: string
  endDate: string
  interfaceId: number
  timeGrouping?: TimeGrouping | ''
  sensorList: {
    sensorId: number
    sensorName: string
    sensorTypeId: number
    dataColumns: string[]
    metadata: any
  }[]
}

export type ChartData = {
  sensorId: number
  sensorName: string
  columnName: string
  chartAxisName: string
  unitMetric: string
  unitImperial: string
  data: { timestamp: string; value: number; endTimestamp?: string; label?: string }[]
  chartType?: string
  isFixed?: number
  selectionKey?: string
}

export type TableColumnMetadata = {
  sensorId: number
  sensorName: string
  columns: {
    columnName: string
    unitMetric: string
    unitImperial: string
  }[]
}

export enum TimeGrouping {
  ONE_MIN = '1 mins',
  FIVE_MINS = '5 mins',
  FIFTEEN_MINS = '15 mins',
  ONE_HOUR = '1 hour',
  SIX_HOURS = '6 hour',
  TWELVE_HOURS = '12 hour',
  ONE_DAY = '1 day',
  TWO_DAYS = '2 days',
}
